import { type MultiselectOption } from '~/@pages_investing/projects/_projects_filtering/MultiSelect'
import { ProjectLoanPurpose } from '~/@pages_investing/projects/_project_types/projectLoanPurpose'
import { getProjectLoanPurposeLabel } from '~/@pages_investing/projects/_projects_ui/project-loan-purpose/labelByProjectLoanPurpose'

export const interestRateOptions: Array<
  MultiselectOption<Record<string, any>>
> = [
  { label: '< 7%', value: { max: 7 } },
  { label: '7 - 9%', value: { min: 7, max: 9 } },
  { label: '9 - 11%', value: { min: 9, max: 11 } },
  { label: '11 - 13%', value: { min: 11, max: 13 } },
  { label: '> 13%', value: { min: 13 } },
]

export const getProjectLoanPurposeOptions = (): Array<
  MultiselectOption<ProjectLoanPurpose>
> =>
  Object.values(ProjectLoanPurpose).map((value) => {
    return {
      value,
      label: getProjectLoanPurposeLabel(value),
    }
  })

export type FilterOptionValues<TOptions extends Array<{ value: any }>> =
  TOptions[number]['value'][]
